import { createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      // padding: 30,
      // border: '1px solid #2d343e',
      // borderRadius: 8,
      // background: '#0b0f14',
    },

    heading: {
      position: 'relative',
      borderBottom: '1px solid #2d343e',
      alignItems: 'center',
      paddingBottom: 20,
      marginBottom: 20,

      '&::before': {
        content: '""',
        background: '#3e8bff',
        height: '1px',
        position: 'absolute',
        width: 42,
        bottom: '-1px',
      },
    },

    buttonCls: {
      marginTop: 10,
      height: '50px !important',
      borderRadius: 8,
      textTransform: 'unset',
      maxWidth: 320,
      fontSize: 15,
    },
    termsContainer: {
      maxHeight: 390,
      background: theme.palette.type === 'dark' ? '#18212e' : COLORS.LIGHT_BACKGROUND,
      border: '1px solid',
      borderColor: theme.palette.type === 'dark' ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER,
      padding: '20px 25px',
      borderRadius: 8,
      marginBottom: 15,
      [theme.breakpoints.down('xs')]: {
        maxHeight: 'unset',
      },
    },
    termsWrap: {
      overflow: 'auto',
      maxHeight: 350,
      [theme.breakpoints.down('xs')]: {
        maxHeight: 'unset',
      },
    },
    // signatureContainer: {
    //   marginTop: 10,
    //   maxWidth: 420,
    //   width: '100%',
    //   background: '#fff',
    //   height: 110,
    //   borderRadius: 8,

    //   [theme.breakpoints.down('xs')]: {
    //     maxWidth: 'unset',
    //   },
    // },
    sigCanvas: {
      backgroundColor: '#fff',
      marginTop: 12,
      border: '1px solid #282E36',
      cursor: 'crosshair',
      borderRadius: 8,
      marginRight: 100,
      width: 320,
      maxHeight: 150,
      minHeight: 120,
      [theme.breakpoints.down('xs')]: {
        width: '100%',
      },
    },
    backBtn: {
      background: '#303946',
      color: 'white',
      '&:hover': {
        background: '#303946',
      },
    },
    buttonsContainer: {
      display: 'flex',
      gap: 10,

      [theme.breakpoints.down('xs')]: {
        marginTop: 10,
        flexDirection: 'column',
      },
    },
  }),
);
